import { Maybe, UserOrderProductPosition } from '@shared/generated'
import ImageWithBg from '@shared/ui/image-with-bg'

import styles from './styles.module.scss'

interface OrderItemPreviewListProps {
  items: Maybe<Maybe<UserOrderProductPosition>[]> | undefined;
}

export default function OrderItemPreviewList ({
  items,
}: OrderItemPreviewListProps) {
  const previewItems = items?.slice(0, 5)
  const hiddenCount = items?.length && items?.length - 5

  return (
    <div className={styles.previews}>
      {previewItems?.map((el, index) => (
        <div key={el?.id} className={styles.previews__item}>
          <ImageWithBg
            src={
              (el?.product?.preview?.url as string) ?? '/icons/flower-grey.svg'
            }
            className={styles.previews__img}
          />
          {index === 4 && hiddenCount && hiddenCount > 0 ? (
            <div className={styles.previews__more}>+ {hiddenCount}</div>
          ) : null}
        </div>
      ))}
    </div>
  )
}
